module.exports = __webpack_public_path__ + "img/antes_despues_303.ece0e411.png";